<ng-container *transloco="let t">
    <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-back-button defaultHref="/"></ion-back-button>
            </ion-buttons>
            <ion-title> {{ t('contact_and_comment') }} </ion-title>
        </ion-toolbar>
    </ion-header>
    <ion-content style="--background: #f5f5fa">
        <div class="main-content">
            <ng-container *ngIf="contactInfo$ | async as contactInfo">
                <ion-list class="menu" [inset]="true">
                    <ion-item
                        *ngIf="contactInfo.phone !== undefined"
                        class="menu-item"
                        [button]="true"
                        [detail]="true"
                        [href]='"tel:" + contactInfo.phone'
                        target="_blank"
                    >
                        <tui-svg src="icon::phone" class="menu-item-icon-lg"></tui-svg>
                        <ion-label>
                            <h4 class="!text-base !font-semibold">{{t('phone_number.label')}}</h4>
                            <p>{{contactInfo.phone}}</p>
                        </ion-label>
                    </ion-item>

                    <ion-item
                        *ngIf="contactInfo.zalo !== undefined"
                        class="menu-item"
                        [button]="true"
                        [detail]="true"
                        [href]="contactInfo.zalo"
                        target="_blank"
                    >
                        <tui-svg src="icon::zalo" class="menu-item-icon-lg"></tui-svg>
                        <ion-label>
                            <h4 class="!text-base !font-semibold">Zalo</h4>
                            <p>{{contactInfo.zalo}}</p>
                        </ion-label>
                    </ion-item>

                    <ion-item
                        *ngIf="contactInfo.facebook_messenger !== undefined"
                        class="menu-item"
                        [button]="true"
                        [detail]="true"
                        [href]="contactInfo.facebook_messenger"
                        target="_blank"
                    >
                        <tui-svg src="icon::facebook-messenger" class="menu-item-icon-lg"></tui-svg>
                        <ion-label>
                            <h4 class="!text-base !font-semibold">Facebook Messenger</h4>
                            <p>{{contactInfo.facebook_messenger}}</p>
                        </ion-label>
                    </ion-item>

                    <ion-item
                        *ngIf="contactInfo.facebook_fanpage !== undefined"
                        class="menu-item"
                        [button]="true"
                        [detail]="true"
                        [href]="contactInfo.facebook_fanpage"
                        target="_blank"
                    >
                        <tui-svg src="icon::facebook" class="menu-item-icon-lg"></tui-svg>
                        <ion-label>
                            <h4 class="!text-base !font-semibold">Facebook</h4>
                            <p>{{contactInfo.facebook_fanpage}}</p>
                        </ion-label>
                    </ion-item>
                </ion-list>
            </ng-container>
        </div>
    </ion-content>
</ng-container>
